import { isEmpty, logError } from 'src/utils/helpers'
import { getFeaturesAndOptions } from 'src/utils/features'
// import notification from 'src/components/Notification'
import Storage from 'src/utils/storage'
import { rootReducers } from 'src/app/reducers'

const initialState = {
  language: 'en',
  selectedLanguage: null,
  settings: null,
  featuresAndOptions: [],
  features: [],
  chat: {},
  sendingData: false,
  isSidebarVisible: true,
  currentlyOpenFeature: '',
  isAddToHomeScreenClosed: false,
  isChatOnlyFeature: false,
  isIdle: true,
  isWidget: false,
  isNotificationHidden: false,
  notificationHeight: 76,
  isAccessibe: false,
  isAppLoading: false,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_APP': {
      Storage.clear()

      // Clear global cache, documents, files, etc.
      Storage.clearCaches('all')

      return state
    }

    case 'APP_UPDATED': {
      Object.keys(rootReducers).forEach(key => {
        if (key !== 'user') {
          Storage.removeItem(`reduxPersist:${key}`)
        }
      })

      // Clear just global cache
      Storage.clearCaches('global')

      // Reload page if user not actively using (clicking, etc.) or show popup
      if (state.isIdle === true) {
        window.location.reload()
      } else {
        try {
          // Not done like rest of the texts because we don't have <LanguageWrapper> component and other required stuff
          // let newVersionMessage = 'Close to get a fresh version of the app.'
          // if (state.hasOwnProperty('language') && state.language === 'fr') {
          //   newVersionMessage = 'Fermez pour obtenir une nouvelle version de l’application.'
          // }
          // NOTE/TODO: This notification component is not used anymore.
          // It's removed, so need to find a way to implement toast notifications here.
          // notification.info({
          //   className: 'kiosk-app-updated',
          //   placement: 'bottomLeft',
          //   message: newVersionMessage,
          //   duration: 0,
          //   onClose: () => {
          //     window.location.reload()
          //   },
          // })
        } catch (e) {
          logError('Could not show new version popup', e)
        }
      }

      return state
    }

    case 'CLEAR_APP_CACHE': {
      // Clear global cache, documents, files, etc.
      Storage.clearCaches()

      return state
    }

    case 'SET_FEATURES': {
      return {
        ...state,
        features: getFeaturesAndOptions(action.payload.features),
      }
    }

    case 'SET_SETTINGS': {
      // If settings not received, set placeholders to avoid too many "undefined" errors
      const defaultSettings = {
        afterHours: {},
        timeZone: null,
        brand: {},
        features: {
          requestQuote: null,
          documents: null,
          changePolicy: null,
          reportClaim: null,
          payments: null,
          inventory: null,
          chat: null,
        },
        featureFlags: [],
        graphics: {
          icons: [],
          screens: [],
        },
        labels: {
          features: {},
        },
        quoteOptions: [],
        chatOptions: {},
        subdomain: '',
        terms: {
          link: '',
        },
        language: '',
        countryIsoCode: 'CA',
      }

      try {
        const newSettings = !isEmpty(action.payload.settings) ? action.payload.settings : {}

        const settings = {
          ...defaultSettings,
          ...state.settings,
          ...newSettings,
        }

        return {
          ...state,
          language:
            settings.hasOwnProperty('language') && settings.language && settings.language.length > 0
              ? settings.language
              : state.language,
          settings: settings,
          // featuresAndOptions: getFeaturesAndOptions(newSettings),
        }
      } catch (e) {
        logError('Could not set new settings', e)

        // Return default
        return {
          ...state,
          settings: {
            ...defaultSettings,
            ...state.settings,
          },
        }
      }
    }

    case 'SET_LANGUAGE': {
      const { language, onEvent } = action.payload

      return {
        ...state,
        language: language,
        // When user manually selects preferred language, update that state separately
        selectedLanguage: onEvent === 'selected' ? language : state.selectedLanguage,
      }
    }

    case 'RESET_LANGUAGE': {
      return {
        ...state,
        language: initialState.language,
        selectedLanguage: initialState.selectedLanguage,
      }
    }

    case 'SET_SENDING_DATA': {
      return {
        ...state,
        sendingData: action.payload.sending,
      }
    }

    case 'SET_CURRENTLY_OPEN_FEATURE': {
      return {
        ...state,
        currentlyOpenFeature: action.payload.feature,
      }
    }

    case 'CLOSE_SIDEBAR': {
      return {
        ...state,
        isSidebarVisible: false,
      }
    }

    case 'OPEN_SIDEBAR': {
      return {
        ...state,
        isSidebarVisible: true,
      }
    }

    case 'SET_NOTIFICATION_BANNER_HIDDEN': {
      return {
        ...state,
        isNotificationHidden: action.payload.hidden,
      }
    }

    case 'SET_NOTIFICATION_HEIGHT': {
      return {
        ...state,
        notificationHeight: action.payload.style,
      }
    }

    case 'AFTER_ADD_TO_HOME_SCREEN_CLOSE': {
      return {
        ...state,
        isAddToHomeScreenClosed: true,
      }
    }

    case 'SET_IS_CHAT_ONLY_FEATURE': {
      return {
        ...state,
        isChatOnlyFeature: action.payload.isChatOnlyFeature,
      }
    }

    case 'SET_IS_IDLE': {
      return {
        ...state,
        isIdle: action.payload.isIdle,
      }
    }

    case 'SET_CHAT': {
      return {
        ...state,
        chat: action.payload.chat,
      }
    }

    case 'SET_IS_WIDGET': {
      return {
        ...state,
        isWidget: action.payload.isWidget,
      }
    }

    case 'SET_IS_ACCESSIBE': {
      return {
        ...state,
        isAccessibe: action.payload.isAccessibe,
      }
    }

    case 'SET_IS_APP_LOADING': {
      return {
        ...state,
        isAppLoading: action.payload.isAppLoading,
      }
    }

    default: {
      return state
    }
  }
}
